import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import { Button } from "./components/ui/button";
import { Slider } from "./components/ui/slider";
import CONTRACT_ABI from './contractABI.json';

const CONTRACT_ADDRESS = '0x6D8DAa86173bd9d260666C2a3d54971827158023';
const MINT_PRICE = BigInt(ethers.parseEther('0.15')); // 0.15 MATIC

const App = () => {
  const [provider, setProvider] = useState(null);
  const [contract, setContract] = useState(null);
  const [nftCount, setNftCount] = useState(1);
  const [account, setAccount] = useState(null);
  const [isMinting, setIsMinting] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        if (window.ethereum) {
          const web3Provider = new ethers.BrowserProvider(window.ethereum);
          setProvider(web3Provider);
          
          const signer = await web3Provider.getSigner();
          const nftContract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);
          setContract(nftContract);

          const accounts = await web3Provider.send("eth_requestAccounts", []);
          if (accounts.length > 0) {
            setAccount(accounts[0]);
          } else {
            console.warn('No accounts found. Please connect your wallet.');
          }
        } else {
          console.error('No Ethereum provider detected. Install MetaMask.');
        }
      } catch (error) {
        console.error("Error initializing Ethereum connection:", error);
      }
    };
    init();
  }, []);

  const handleMint = async () => {
    if (!contract || !account) {
      console.error("Contract or account not found. Please try again.");
      return;
    }
    setIsMinting(true);
    try {
      const totalPrice = MINT_PRICE * BigInt(nftCount);
      
      const estimatedGas = await contract.mint.estimateGas(nftCount, [], { value: totalPrice });
      console.log("Estimated gas:", estimatedGas.toString());

      const tx = await contract.mint(nftCount, [], {
        value: totalPrice,
        gasLimit: estimatedGas * BigInt(120) / BigInt(100) // Add 20% buffer
      });
      console.log("Transaction sent:", tx.hash);
      await tx.wait();
      console.log(`Successfully minted ${nftCount} NFT(s)!`);
    } catch (error) {
      console.error("Error minting NFT:", error);
      if (error.reason) console.error("Error reason:", error.reason);
      if (error.code) console.error("Error code:", error.code);
      if (error.message) console.error("Error message:", error.message);
      if (error.data) console.error("Error data:", error.data);
    } finally {
      setIsMinting(false);
    }
  };

  const totalPrice = MINT_PRICE * BigInt(nftCount);

  return (
    <div className="relative w-full min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat" style={{backgroundImage: "url('/images/banner.jpg')"}}>
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      
      <div className="relative z-10 w-full max-w-md">
        {/* Profile Picture */}
        <div className="mx-auto w-32 h-32 rounded-full border-4 border-white overflow-hidden bg-gray-200 mb-6">
          <img src="/images/profile.jpg" alt="Profile" className="w-full h-full object-cover" />
        </div>

        {/* Minting Controls */}
        <div className="bg-white bg-opacity-90 shadow-lg rounded-lg p-6 mx-4">
          <h1 className="text-2xl font-bold mb-4 text-center text-gray-800">Mutant Zuki</h1>
          
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Number of NFTs to mint: {nftCount}
            </label>
            <Slider
              defaultValue={[1]}
              max={100}
              step={1}
              onValueChange={(value) => setNftCount(value[0])}
              className="w-full"
            />
          </div>
          
          <p className="mb-4 text-center text-gray-600">
            Total Price: {ethers.formatEther(totalPrice)} MATIC
          </p>
          
          <Button 
            onClick={handleMint}
            disabled={isMinting}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded disabled:bg-gray-400"
          >
            {isMinting ? 'Minting...' : 'Mint Now'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default App;